import Spinner from "../../spinner/Spinner";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PopularBoxes from "../PopularBoxes/PopularBoxes";
import { boxProducts } from "../../../api/modules/b2droppie.class";
import { toggleLoader } from "../../../redux/slices/loaderSlice";
import BackdropLoader from "../../BackdropLoader/BackdropLoader";
import BoxListCarousel from "../../BoxListCarousel/BoxListCarousel";
import ProductRightSlider from "../../ProductRightSlider/ProductRightSlider";

export const BoxDetail = () => {
  const dispatch = useDispatch();
  const { slugId } = useParams();
  const [boxId, setBoxId] = useState();
  const [unbox, setUnbox] = useState();
  const [boxItems, setboxItems] = useState();
  const [loading, setLoading] = useState(true);
  const [reFetch, setRefetch] = useState(false);
  const [spinnerData, setSpinnerData] = useState();
  const [featuredData, setfeaturedData] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayData, setOverlayData] = useState();
  const fetchAgain = useSelector((state) => state.theme.reFetch);
  const isLoading = useSelector((state) => state?.loader?.isLoading);

  const decryptData = () => {
    try {
      const decodedData = window?.atob(slugId)?.toString();
      return decodedData;
    } catch (error) {
      console.error("Decryption error:", error);
    }
  };

  useEffect(() => {
    const decryptedData = decryptData();

    try {
      dispatch(toggleLoader({ isLoading: true }));

      const api = async () => {
        const response = await boxProducts(decryptedData);
        setBoxId(response?.data?.data?.id);
        await setboxItems(response?.data?.data);
        setLoading(false);
        await setSpinnerData(response?.data?.spinner);
        await setUnbox(response?.data?.data);
        dispatch(toggleLoader({ isLoading: false }));
      };

      api();
    } catch (err) {
      console.log(err);
    }
  }, [slugId, reFetch, fetchAgain]);

  return isLoading ? (
    <BackdropLoader show={isLoading} />
  ) : (
    <div>
      {boxItems?.products && spinnerData ? (
        <>
          <ProductRightSlider
            showOverlay={showOverlay}
            overlayData={overlayData}
            setShowOverlay={setShowOverlay}
          />
          <Spinner
            unbox={unbox}
            boxId={boxId}
            setRefetch={setRefetch}
            spinnerData={spinnerData}
            itemsData={boxItems?.products}
            boxPrice={boxItems?.box_price}
            boximage={boxItems?.box_images.image}
            boxFormatedPrice={boxItems?.formatted_box_price}
          />
          <BoxListCarousel
            spinner="spinner"
            loading={loading}
            boxName={boxItems?.name}
            showOverlay={showOverlay}
            setShowOverlay={setShowOverlay}
            setOverlayData={setOverlayData}
            cardData={{ box: [...boxItems?.products] }}
            WheelPage={true}
          />
          <PopularBoxes cardData={featuredData} />
          <div className="d-center m-3 p-5">
            <p style={{color:"#BAB4C3",fontStyle:"italic",fontWeight:"500",fontSize:"10px"}}>
              *If your winnings are lower than your wagered amount, you’ll still receive the product and XP points equal to the difference.
            </p>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
